import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { PageBaseComponent } from '@app/pages/page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { BottomNavigationSelectEvent } from '@progress/kendo-angular-navigation';
import { State } from '@progress/kendo-data-query';
import { Socket } from 'ngx-socket-io';
import { SwUpdate } from '@angular/service-worker';


@Component({
  selector: 'app-root',
  styles: [`
    :host {
      padding: 0;
    } 
    p.title {
      margin: 2px;
    }
    .k-avatar-solid.k-avatar-primary {
      background-color: transparent;
    }
  `],
  template: `      
  
    <kendo-appbar position="top" *ngIf="isAdmin">

      <kendo-appbar-section>      
        <p class="title">{{title}}</p>
      </kendo-appbar-section>

      <kendo-appbar-spacer></kendo-appbar-spacer>       

      <kendo-appbar-section>
        <kendo-avatar [imageSrc]="currentUser.image" shape="circle" width="26px" height="26px" (click)="goProfile()"></kendo-avatar>
      </kendo-appbar-section>

    </kendo-appbar>

    <router-outlet></router-outlet>        

    <kendo-bottomnavigation [items]="items" [themeColor]="'primary'" [fill]="'solid'" [border]="false" (select)="onSelect($event)" *ngIf="isAdmin">
    
      <ng-template kendoBottomNavigationItemTemplate let-item>
        <kendo-badge-container>
          <kendo-avatar [imageSrc]="item.image"></kendo-avatar>             
        </kendo-badge-container>
      </ng-template>
      
    </kendo-bottomnavigation>

  `,    
})
export class AppComponent extends PageBaseComponent implements OnInit {

  public title = `Grúas Delher v${environment.version} - Suc: ${environment.branchName}`; 
  
  public items: Array<any> = [];


  constructor(public authService: AuthService, protected router: Router, protected service : DatasourceService, private socket: Socket, private swUpdate: SwUpdate) {

    super(authService, router)
    // console.log(this.constructor.name);

    this.items = this.mapItems(router.config);
    this.items[0].selected = true;
          
    if ('serviceWorker' in navigator) {
      console.log("Will the service worker register?");
      navigator.serviceWorker.register('/ngsw-worker.js')
        .then(function(reg){
          console.log("Yes, it did.", reg.scope);
        }).catch(function(err) {
          console.log("No it didn't. This happened:", err)
        });                  
    }

    if (!("Notification" in window)) {
      alert(
        "Este navegador no es compatible con las notificaciones de escritorio",
      );
    }
    else {
      Notification.requestPermission()
        .then(function (result) {
          console.log("PERMISSION -> " + result);
          if (result === "granted") {
            
            // navigator.serviceWorker.ready
            //   .then((registration) => {
            //     registration.showNotification("Vibration Ready", {
            //       body: "Buzz! Registrado!",
            //       icon: "../assets/icons/icon-128x128.png",
            //       // vibrate: [200, 100, 200, 100, 200, 100, 200],
            //       tag: "vibration-sample",
            //     });
            //   })
            //   .catch(function(err) {
            //     console.log("Error. navigator.serviceWorker.ready", err)
            //   }); 

          }
        });
    }

    this.socket.on('ENTRADAS_VEHICULOS_UPDATED', (res: any) => {
      // console.log('ENTRADAS_VEHICULOS_UPDATED', res);
      if(res){
        let info: any = res[0];

        if(info.vehicle_status_name == 'LIBERADO'){

          console.log(`Vehiculo Liberado en ${info.deposit_name}: ${info.marck}, Color: ${info.color}, Placa: ${info.plaque}, No de serie: ${info.serie}`);

          var title = `Vehiculo liberado en ${info.deposit_name}`;
          var options = {
            body: `${info.marck}, Color: ${info.color}, Placa: ${info.plaque}, No de serie: ${info.serie}`,
            icon: info.vehicle_type_image,
          };        

          let state : State = {
            skip: 0, 
            take: 0, 
            // sort: [{field: 'sku_exp', dir: 'desc'}], 
            filter: {
              logic: "and",
              filters: [
                {
                  field: 'id_vehicle_inventory',
                  operator: 'eq',
                  value: info.id
                }
              ]
            }, 
            group: []
          }
          
          this.service.get('vehicles_inventories_photos', state)
            .subscribe(
              (res: any) => {
                // console.log("RESPONSE------: ", res);
                if(res.data.length)
                  options.icon = res.data[0].photo;
                
                this.showNotification(title, options);
                
              },
              (fail: any) => {        
                console.log("Error", fail);
              }
            );

        }

      }

    });

    this.socket.on('SALIDAS_SERVICIOS_INSERTED', (res: any) => {
      // console.log('SALIDAS_SERVICIOS_INSERTED', res);
      if(res){
        let info: any = res[0];
        console.log(info);
        console.log(`Salida de Servicio: Grúa ${info.crane_name}, ${info.person_operator_name}, ${info.place}`);

        var title = `Salida de servicio Grúa ${info.crane_name}`;
        var options = {
          body: `Operador: ${info.person_operator_name}, Destino: ${info.place}`,
          icon: environment.assets.DEFAULT_SERVICE_COLOR,
        };        

        this.showNotification(title, options);

      }

    });

  }

  public showNotification(title: any, options: any) {
    try {
      console.log('NOTIFICATION => new Notification');
      new Notification(title, options);
    }
    catch(e) {
      console.log('NOTIFICATION => navigator.serviceWorker.ready');
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.showNotification(title, options);
        })
        .catch(function(err) {
          console.log("Error. navigator.serviceWorker.ready", err)
        }); 
    }
  }

  public onSelect(ev: BottomNavigationSelectEvent): void {

    this.router.navigate([ ev.item.path ]);

  }

  public mapItems(routes: any[]): any[] {

    return routes.filter(function (r) {
        return r.path === 'home' || r.path === 'profile' || r.path === 'vehicles' || r.path === 'history';
      }).map(item => {
        return {
          text: item.text,
          image: item.image,
          path: item.path ? item.path : ''
        };
      });

  }

  public goProfile() {

    this.router.navigate(['/profile']);

  }

  ngOnInit() {

    console.log('this.swUpdate.isEnabled', this.swUpdate.isEnabled);
    if (this.swUpdate.isEnabled) {

        this.swUpdate.available.subscribe(() => {

            if(confirm("Nueva versión disponible. ¿Desea cargar nueva versión?")) {

                window.location.reload();
            }
        });
    }        
  }

}
